/* eslint-disable angular/timeout-service */
import React, { useState, useEffect } from 'react';

function VideoForm() {
    const [videoNameValue, setVideoNameValue] = useState();
    const [videoNameTempValue, setVideoNameTempValue] = useState();
    const [videoNameMsg, setVideoNameMsg] = useState();
    // debounce for input
    useEffect(() => {
        const timeout = setTimeout(() => {
            setVideoNameValue(videoNameTempValue);
        }, 0);
        return () => clearTimeout(timeout);
    }, [videoNameTempValue]);
    const handleMsg = (event) => {
        setVideoNameMsg(event.target.value);
    };
    return (
        <>
            <div className='container-video-form'>
                <input
                    className='input-text-size box-input search-field max-width-100 personal-video-float-left'
                    type='text'
                    required
                    data-testid='video-name'
                    id='video-name'
                    placeholder='Video Name (Required)'
                    value={videoNameValue}
                    onChange={({ target }) => setVideoNameTempValue(target.value)}
                />
                <input
                    className='input-text-size box-input search-field max-width-100 personal-video-float-right'
                    type='text'
                    data-testid='custom-email-message'
                    id='custom-email-message'
                    placeholder='Custom Email Message (Optional)'
                    value={videoNameMsg}
                    onChange={handleMsg}
                />
            </div>
        </>
    );
}

export default VideoForm;
